import { getTestId, tokens } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  rtn: '8607972097',
  state: 'none',
  title: 'OTP verification',
  subTitle: 'sent successfully to ',
  infoTextTop: 'enter OTP',
  loadingTitle: 'verifying your number',
  changeNumberCta: 'change',
  infoTextBottom: '',
  primaryCtaProps: {
    title: 'proceed',
    buttonType: 'primary',
    onPress: {
      id: 'primaryCtaProps'
    }
  },
  autocomplete: false,
  numberOfInputs: 6,
  startCounter: true,
  resendTimerCount: 5,
  onChangeCtaPress: {
    id: 'changeCta'
  },
  secondaryCtaProps: {
    title: 'resend',
    counterSuffix: 's',
    buttonType: 'tertiary',
    version: 'fixed-padding',
    onPress: {
      id: 'secondaryCta'
    },
    style: {
      marginTop: tokens.spacing.SPACING_16
    }
  },
  onSuccess: {
    id: 'after-success-user-action-object'
  },
  onUserAction: (event, extraData) => {
    if (typeof event === 'function') {
      console.log('@@ onUserAction event function', event(), extraData);
    } else console.log('@@ onUserAction object:', event, extraData);
  },
  otpInputContainerStyle: {
    marginTop: tokens.spacing.SPACING_0
  }
}, getTestId('OtpWidgetContainer'));